import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { authSelectors } from '@app2/store/auth/auth.selectors';
import { AuthStep } from '@core/models';
import { authActions } from '@app2/store/auth/auth.actions';

export class AuthFacade {
  private store = inject(Store);

  public step = this.store.selectSignal(authSelectors.selectStep);

  public errors = this.store.selectSignal(authSelectors.selectErrors);

  public isLoading = this.store.selectSignal(authSelectors.selectIsLoading);

  setStep(step: AuthStep): void {
    this.store.dispatch(authActions.setStep({ step }));
  }

  getCode(email: string): void {
    this.store.dispatch(authActions.getCode({ email }));
  }

  verifyCode(email: string, code: string): void {
    this.store.dispatch(authActions.verifyCode({ email, code }));
  }

  reset(): void {
    this.store.dispatch(authActions.reset());
  }
}
